import { Button, Grid as MaterialGrid } from '@material-ui/core';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import { Dialog } from '@progress/kendo-react-dialogs';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import api from '../../../../libs/api';
import { resetTreeData } from '../../../core/store/features/asite';
import useStyles from '../../styles/useStyles';
import FolderTree from './FolderTree';
import { useToastify } from '../../../../Hooks';

const foldersToAddInit: any = [];

const AddFolderDialog = ({
    newFolderModalVisible,
    setNewFolderModalVisible,
    setaddFoldersInGrid,
    singleSelect,
    setSelectedPath,
}: any) => {
    const dispatch = useDispatch();
    const [foldersToAdd, setFoldersToAdd] = useState(foldersToAddInit);
    const [allLoadedAsiteFolders, setAllLoadedAsiteFolders] = useState([]);

    const { showToastSuccess, showToastError } = useToastify();

    const takeFoldersAndSubmit = () => {
        api.post('/api/v2/AsiteRelaticsSync/AddRelaticsConfigurationFolders', {
            data: foldersToAdd,
            safe: true,
        })
            .then((res: any) => {
                if (res) {
                    showToastSuccess(`All folders have been added successfully!`);
                    setaddFoldersInGrid(foldersToAdd);
                    setNewFolderModalVisible(!newFolderModalVisible);
                } else {
                    setNewFolderModalVisible(!newFolderModalVisible);
                    showToastError(`Something went wrong during adding folders`);
                }
                setFoldersToAdd(foldersToAddInit);
                dispatch(resetTreeData());
            })
            .catch(() => {
                showToastError(`Something went wrong during adding folders`);
                setNewFolderModalVisible(!newFolderModalVisible);
            });
    };
    const classes = useStyles();

    return (
        <div>
            {newFolderModalVisible && (
                <Dialog
                    title={'Add new configuration folder'}
                    onClose={() => {
                        setFoldersToAdd(foldersToAddInit);
                        setNewFolderModalVisible(!newFolderModalVisible);
                    }}
                    width={singleSelect ? '30%' : '70%'}
                    className={classes.dialog}
                    autoFocus={true}
                >
                    <MaterialGrid container style={{ marginTop: '0px' }}>
                        <FolderTree
                            setFoldersToAdd={setFoldersToAdd}
                            allLoadedAsiteFolders={allLoadedAsiteFolders}
                            setAllLoadedAsiteFolders={setAllLoadedAsiteFolders}
                            singleSelect={singleSelect}
                            setSelectedPath={setSelectedPath}
                        />
                        {!singleSelect ? (
                            <MaterialGrid
                                item
                                style={{ width: singleSelect ? '30%' : '50%', maxHeight: 490, minHeight: 490 }}
                            >
                                <span className={classes.selectedFoldersTitle}>Selected folders</span>
                                <div className={classes.selectedFolders}>
                                    {foldersToAdd?.map((folder: any) => (
                                        <span>
                                            <span className={classes.verticalAlignItem}>
                                                <CreateNewFolderIcon />
                                            </span>
                                            {folder.fullPath}
                                        </span>
                                    ))}
                                </div>
                            </MaterialGrid>
                        ) : (
                            <React.Fragment />
                        )}
                    </MaterialGrid>
                    {!singleSelect ? (
                        <div className={classes.buttonGroup}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => {
                                    setFoldersToAdd(foldersToAddInit);
                                    setNewFolderModalVisible();
                                }}
                                style={{ marginRight: '1%' }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    if (singleSelect) {
                                        setNewFolderModalVisible(!newFolderModalVisible);
                                    } else {
                                        takeFoldersAndSubmit();
                                    }
                                }}
                                style={{ marginRight: '3%', width: '7%' }}
                            >
                                Save
                            </Button>
                        </div>
                    ) : (
                        <React.Fragment />
                    )}
                </Dialog>
            )}
        </div>
    );
};

export default AddFolderDialog;
